import React from 'react';
import { Layout, Spin } from 'antd';
import sb from './SpinBlock.module.scss';

const SpinBlock = () => {
    return (
        <Layout className={sb.container}>
            <Spin className={sb.Spin} />
        </Layout>
    );
};

export default SpinBlock;
